import EnquiryTripItem from "./EnquiryTripItem";

export default EnquiryTripItem;
